import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

import operator from "../locales/operator";

const LanguageContext = createContext();

export const LANGUAGES = [
  { code: "kk", label: "ҚАЗ" },
  { code: "ru", label: "РУС" },
];

const STORAGE_KEY = "app_language";

const getStoredLanguage = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "kk" || stored === "ru") return stored;
  // Браузер тілі орысша болса — орысша, әйтпесе қазақша.
  return (navigator.language || "").toLowerCase().startsWith("ru") ? "ru" : "kk";
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

/** Аударма функциясы. Кілт табылмаса — кілттің өзін қайтарады (көзге түссін). */
export const useT = () => useLanguage().t;

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getStoredLanguage);

  const setLanguage = useCallback((code) => {
    if (code !== "kk" && code !== "ru") return;
    localStorage.setItem(STORAGE_KEY, code);
    setLanguageState(code);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = operator[language] || operator.kk;
      let value = dict[key];
      if (value === undefined) {
        // Екінші тілден іздеп көреміз, сосын кілттің өзін қайтарамыз.
        const fallback = language === "kk" ? operator.ru : operator.kk;
        value = fallback[key] !== undefined ? fallback[key] : key;
      }
      if (vars) {
        Object.entries(vars).forEach(([k, v]) => {
          value = value.replace(new RegExp(`\\{${k}\\}`, "g"), v);
        });
      }
      return value;
    },
    [language],
  );

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
